import React, { useState, useEffect } from 'react'
import axios from '../../../config/axios/axios';
import EmailVerified from '../../components/verification/email-verified';
import NoToken from '../../components/verification/no-token';
import useQuery from '../../../shared/functions/functions';
import { Redirect } from 'react-router-dom';

function VerifyEmailPrivate() {
    const [emailNotVerified, setEmailNotVerified] = useState(true);
    const query = useQuery();
    const verificationToken = query.get("verificationToken");
    const [token] = useState(verificationToken);

    function sendVerifyEmailRequest(token) {
        axios.post(`client/private/verify-email`, {token: token})
                .then(response =>
                    {
                        console.log('response', response);
                         setEmailNotVerified(false)
                    })
                .catch((error) => {
                    setEmailNotVerified(true);
                });
    }

    useEffect(() => {
        sendVerifyEmailRequest(token);
    }, [])
    
    if (!token) {
        return returnNoTokenProvided()
    }

    if (emailNotVerified) {
        return (
            <div>
                <NoToken />
            </div>
        )
    }

    return (
        <div>
            <EmailVerified />
        </div>
    )  
}

function returnNoTokenProvided() {
    return (
        <div>
            <Redirect to={"/page-not-found"} />
        </div>
    )
}

export default VerifyEmailPrivate
